import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { View } from '@shared/components/View';
import { MBTextBody1 } from '@shared/components/typography';
import { EmailField } from '@shared/data/entity/fields/EmailField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: EmailField;
  style: StyleProp<ViewStyle>;
}

const emailStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

const MAX_EMAILS_TO_SHOW = 2;

export function EmailCollectionViewField({ field, style }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const emailsToShow = field.emails.slice(0, MAX_EMAILS_TO_SHOW);
  const remainingEmailCount = field.emails.length - MAX_EMAILS_TO_SHOW;

  return (
    <CardCollectionViewFieldContainer style={[emailStyles, style]}>
      <View>
        {emailsToShow.map((email: string) => (
          <View key={email}>
            <MBTextBody1
              numberOfLines={1}
              style={{
                // @ts-ignore
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                display: 'block',
              }}
            >
              {email}
            </MBTextBody1>
          </View>
        ))}
        {remainingEmailCount > 0 && (
          <View>
            <MBTextBody1 numberOfLines={1}>+{remainingEmailCount} more</MBTextBody1>
          </View>
        )}
      </View>
    </CardCollectionViewFieldContainer>
  );
}
